class Storage {

  constructor() {
    if ( this.can() ) {
      return this;
    } else {
      console.error('sessionStorage not support');
      return null;
    }
  }

  can() {
    return typeof sessionStorage != 'undefined';
  }

  get(key) {
    let _value = sessionStorage.getItem(key);

    if ( _value ) {
      return JSON.parse(_value).key;
    }

    return null;
  }

  set(key, value) {
    let _value = {
      key: value
    };

    sessionStorage.setItem(key, this.JsonToStr(_value));
  }

  JsonToStr(val) {
    return JSON.stringify(val);
  }

  remove(key) {
    sessionStorage.removeItem(key);
  }
}

export default new Storage();
